export const INIT_GAME_DATA = "INIT_GAME_DATA";
export const INIT_GAME_DATA_COMPLETE = "INIT_GAME_DATA_COMPLETE";
export const GET_OR_CREATE_GAME_COMPLETE = "GET_OR_CREATE_GAME_COMPLETE";
export const CLEAR_GAME = "CLEAR_GAME";
export const ON_ERROR = "ON_ERROR";
